<!-- 组件说明 -->
<template>
  <div class="con ">
    <div class="helpcenter">
      <div class="l">
        <div class="help-menu c-pointer">
          <h3
            class="help-menu-title "
            @click="meau1 = !meau1"
            :class="meau1 ? 'active' : ''"
          >
            <i class="help-m-icon"></i>系统规则
            <i v-if="meau1" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </h3>
          <ul class="help-menu-list" v-show="meau1">
            <li
              v-for="(item, index) in articleList"
              @click="changeArt(item, index)"
              :class="activeId1 == item.id ? 'activeli' : ''"
              :title="item.title"
            >
              <i></i> <em></em> {{ item.title }}
            </li>
          </ul>

          <h3
            class="help-menu-title "
            @click="meau3 = !meau3"
            :class="meau3 ? 'active' : ''"
          >
            <i class="help-m-icon"></i>帮助中心
            <i v-if="meau3" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </h3>
          <ul class="help-menu-list" v-show="meau3">
            <li
              v-for="(item, index) in certList"
              @click="changeArt(item, index)"
              :class="activeId1 == item.id ? 'activeli' : ''"
              :title="item.title"
            >
              <i></i> <em></em> {{ item.title }}
            </li>
          </ul>
          <h3
            class="help-menu-title "
            @click="meau2 = !meau2"
            :class="meau2 ? 'active' : ''"
          >
            <i class="help-m-icon"></i>平台公告
            <i v-if="meau2" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </h3>
          <ul class="help-menu-list" v-show="meau2">
            <li
              v-for="(item, index) in noticeList"
              @click="changeArt(item, index, 2)"
              :class="activeId1 == item.id ? 'activeli' : ''"
              :title="item.title"
            >
              <i></i> <em></em> {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="r">
        <div
          v-if="articleList.length > 0 || list"
          class="content"
          v-html="list.content ? list.content : articleList[0].content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      articleList: [],
      noticeList: [],
      certList: [],
      list: "",
      activeId1: "",
      meau1: true,
      meau2: true,
      meau3: true,
      totalList: []
    };
  },

  watch: {
    $route: function(t, f) {
      this.activeId1 = t.query.id;
      this.totalList.map(item => {
        if (item.id == t.query.id) {
          this.list = item;
        }
      });
    }
  },
  computed: {},
  methods: {
    async getArticleList() {
      const data = await this.$store.dispatch("sessionData/getHelper");

      this.totalList = data;
      this.totalList.forEach(item => {
        if (item.articleCategoryId == 1) {
          this.articleList.push(item);
        } else if (item.articleCategoryId == 7) {
          this.certList.push(item);
        } else {
          this.noticeList.push(item);
        }
        if (item.id == this.activeId1) {
          this.list = item;
        }
      });
      // this.$api.GET_NOTICELIST().then(res=>{
      //   this.totalList = res.data
      //   res.data.forEach(item=>{
      //     if(item.articleCategoryId == 1){
      //       this.articleList.push(item)
      //     }else if(item.articleCategoryId == 7){
      //       this.certList.push(item)
      //     }
      //     else {
      //         this.noticeList.push(item)
      //     }
      //     if(item.id == this.activeId1){
      //       this.list = item
      //     }
      //   })
      // })
    },
    changeArt(item, index) {
      //console.log(item);

      this.list = item;
      this.$route.query.id = item.id;
      this.activeId1 = item.id;
    }
  },
  mounted() {},
  created() {
    this.activeId1 = this.$route.query.id;
    this.getArticleList();
  }
};
</script>
<style>
.r .content img {
  max-width: 885px;
}
</style>
<style lang="scss" scoped>
.helpcenter {
  display: flex;
  width: 100%;
}
.l {
  margin-top: 20px;
  width: 235px;
}
.r {
  padding: 30px 40px;
  width: calc(100% - 235px);
}

.help-menu {
  width: 235px;
  padding-bottom: 34px;
  border: 1px solid #d2d2d2;
  border-radius: 2px;
  .help-menu-title {
    position: relative;
    width: 235px;
    height: 39px;
    margin-top: -1px;
    margin-left: -1px;
    background-color: #f2f2f2;
    padding-left: 50px;
    @include font(14px, #3f3f4d, left, 400, 39px);

    .el-icon-arrow-up,
    .el-icon-arrow-down {
      position: absolute;
      right: 20px;
      top: 50%;
      margin-top: -9px;
    }
  }
  .active {
    background: #f43737;

    @include font(14px, #ffffff, left, 400, 39px);
  }
}
.help-menu-list {
  li {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    color: #3f3f4d;
    display: block;
    margin: 0 15px;
    padding-left: 30px;
    font-size: 14px;
    line-height: 45px;
    border-bottom: 1px dashed #bcbfc8;
    cursor: pointer;
    &:hover {
      color: #fa4b4b;
      em,
      i {
        background-color: #fa4b4b;
      }
    }
    em {
      display: block;
      position: absolute;
      left: 10px;
      top: 20px;
      width: 5px;
      height: 5px;
      background-color: #bcbfc8;
    }
    i {
      display: block;
      width: 5px;
      height: 27px;
      position: absolute;
      background: none;
      left: -16px;
      top: 9px;
    }
    &:last-child {
      border: none;
    }
  }

  .activeli {
    color: #fa4b4b;
    em,
    i {
      background-color: #fa4b4b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/helpcenter/index.vue